import { render, staticRenderFns } from "./MontageTable.vue?vue&type=template&id=4a083333&scoped=true"
import script from "./MontageTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MontageTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MontageTable.vue?vue&type=style&index=0&id=4a083333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a083333",
  null
  
)

export default component.exports